import React from "react";

function ContactAdmin() {
  return (
    <div>
      <span>
        You don't have access to this tool. If you need access to this tool, please contact us.
      </span>
    </div>
  );
}

export default ContactAdmin;
